export default "__VITE_ASSET__D7_89Czd__"